/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
import moment from "moment";

const browserLocale = navigator.language;
if (browserLocale) {
  moment.locale(browserLocale);
}

export function getPrettyDate(date: Date) {
  return moment(date).format("L");
}

export function getPrettyDateTime(date: Date) {
  return moment(date).format("L HH:mm");
}
